import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { TextAreaModule } from '@progress/kendo-angular-inputs';
import { IconComponent } from 'src/app/shared/components/ui/icon/icon.component';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { TrainingAssessmentDto } from 'src/models/ts/training-assessment-dto.model';

@Component({
  selector: 'bizz-set-all-grades-assessment',
  standalone: true,
  imports: [
    TranslatePipe,
    TextAreaModule,
    ComboBoxModule,
    ReactiveFormsModule,
    IconComponent,
  ],
  templateUrl: './set-all-grades-assessment.component.html',
  styleUrl: './set-all-grades-assessment.component.scss'
})
export class SetAllGradesAssessmentComponent {
  public skillGradeId = new FormControl();
  public skillGradeChangeReason = new FormControl();
 
  public constructor( public dialogRef: DialogRef<unknown>,
    @Inject(DIALOG_DATA) public data: TrainingAssessmentDto,) {
  }

  public save(): void {
    const output = {
      skillGradeId: this.skillGradeId.getRawValue() ?? null,
      skillGradeChangeReason: this.skillGradeChangeReason.getRawValue(),
    }
    this.dialogRef.close(output);
  }
}
